/**
 * There will be one reducer file per page / common component
 */
 import {
    TYPE_FILTER_HANDLE,
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

const initialState = {
    loading: false,
    filterApplied:false,
    typeSelected:[],
    otherFilterApplied:false,
    accountSelected:[],
    physicianSelected:[],
    procedureSelected:[],
    createdSelected:[]
};

const TypeFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case TYPE_FILTER_HANDLE:
            return {
                ...state,
                loading: true,
                filterApplied: action.payload.filterApplied,
                typeSelected: action.payload.typeSelected,
                otherFilterApplied: action.payload.otherFilterApplied,
                accountSelected: action.payload.accountSelected,
                physicianSelected: action.payload.physicianSelected,
                procedureSelected: action.payload.procedureSelected,
                createdSelected: action.payload.createdSelected,
            };
        default: {
            return { ...state };
        }
    }
};

export default TypeFilterReducer;
